// extracted by mini-css-extract-plugin
module.exports = {"plain-features":"PlainFeatures_plain-features__9YXZN","plain-features-block":"PlainFeatures_plain-features-block__YU8z5","description":"PlainFeatures_description__ubCPU"};